import { useAuth } from '../../../../hooks/useAuth';

export default function useAccountPage() {
  const { user } = useAuth();

  return {
    email: user?.email ?? null,
  };
}
